import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api';
import './Login.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [twoFactorToken, setTwoFactorToken] = useState('');
  const [require2FA, setRequire2FA] = useState(false);
  const [tempToken, setTempToken] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await api.post('/api/auth/login', { email, password });
      if (res.data.require2FA) {
        setRequire2FA(true);
        setTempToken(res.data.tempToken);
        return;
      }
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    }
  };

  const handle2FA = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await api.post('/api/auth/login/2fa', {
        tempToken,
        token: twoFactorToken,
      });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid 2FA code');
    }
  };

  return (
    <div className="login-page">
      {/* Background decoration */}
      <div className="login-bg-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>

      {/* ── Back to Home arrow ── */}
      <Link
        to="/"
        style={{
          position: 'fixed',
          top: '1.25rem',
          left: '1.25rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.4rem',
          color: 'rgba(255,255,255,0.75)',
          fontSize: '0.9rem',
          fontWeight: 500,
          zIndex: 100,
          transition: 'color 0.2s',
          textDecoration: 'none',
        }}
        onMouseEnter={e => e.currentTarget.style.color = '#fff'}
        onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.75)'}
      >
        ← Home
      </Link>

      <div className="login-container">
        {/* Left Branding Panel */}
        <div className="login-brand">
          <div className="brand-lock">🔐</div>
          <h1>Recovery Vault</h1>
          <p className="brand-tagline">
            Institutional‑grade security for your digital assets
          </p>
          <div className="brand-stats">
            <div className="brand-stat">
              <span className="stat-number">$126M+</span>
              <span className="stat-label">Protected</span>
            </div>
            <div className="brand-stat">
              <span className="stat-number">99.8%</span>
              <span className="stat-label">Verification</span>
            </div>
          </div>
        </div>

        {/* Right Form Panel */}
        <div className="login-form-panel">
          {require2FA ? (
            <>
              <div className="form-header">
                <h2>Two‑Factor Authentication</h2>
                <p>Enter the 6‑digit code from your authenticator app</p>
              </div>

              {error && <div className="login-error">{error}</div>}

              <form onSubmit={handle2FA} className="login-form">
                <div className="input-group">
                  <span className="input-icon">🔢</span>
                  <input
                    type="text"
                    placeholder="6‑digit code"
                    value={twoFactorToken}
                    onChange={e => setTwoFactorToken(e.target.value)}
                    required
                    maxLength={6}
                  />
                </div>

                <button type="submit" className="login-btn">
                  <span>Verify</span>
                  <span className="btn-arrow">→</span>
                </button>
              </form>
            </>
          ) : (
            <>
              <div className="form-header">
                <h2>Welcome back</h2>
                <p>Enter your credentials to access your vault</p>
              </div>

              {error && <div className="login-error">{error}</div>}

              <form onSubmit={handleLogin} className="login-form">
                <div className="input-group">
                  <span className="input-icon">📧</span>
                  <input
                    type="email"
                    placeholder="Email address"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                  />
                </div>

                <div className="input-group">
                  <span className="input-icon">🔒</span>
                  <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    required
                  />
                </div>

                <button type="submit" className="login-btn">
                  <span>Unlock Vault</span>
                  <span className="btn-arrow">→</span>
                </button>

                <div className="form-links">
                  <Link to="/forgot-password" className="forgot-link">
                    Forgot password?
                  </Link>
                  <p className="switch-link">
                    Don't have an account? <Link to="/signup">Create one</Link>
                  </p>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Login;